// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../../services/types.tsx';

export const setSpotlightStepId =
	(stepId: string): Action<State> =>
	({ setState }) => {
		setState({ spotlightStepId: stepId });
	};
